import { ProfilerOptions, Profiler } from '@weblite/profiler'
import { ProfilerAction } from './types'

export enum UploadSource {
  CHAT = 'chat',
  STORY = 'story',
}

export function createUploadProfiler(
  source: UploadSource,
  options?: ProfilerOptions,
) {
  const uploadProfiler = new Profiler(ProfilerAction.UPLOAD, options)
  const conversionSubAction = uploadProfiler.createSubAction('conversion')

  let type = ''
  let size = 0

  const startUpload = (fileType: string, fileSize: number) => {
    uploadProfiler.start()
    type = fileType
    size = fileSize
  }

  const startConversion = () => conversionSubAction.start()

  const stop = (additionalData?: Record<string, unknown>) => {
    const conversionDuration = conversionSubAction.getTotalExecutionTime()
    const totalDuration = uploadProfiler.getTotalDuration()

    const sizeInMB = size / (1024 * 1024)
    const speedMBPerSecond = sizeInMB / (totalDuration / 1000)
    const uploadSpeedMBPerSecond =
      sizeInMB / ((totalDuration - conversionDuration) / 1000)

    const conversionSpeedMBPerSecond = conversionDuration
      ? sizeInMB / (conversionDuration / 1000)
      : 0

    uploadProfiler.stop({
      fileType: type,
      source,
      speedMBPerSecond,
      uploadSpeedMBPerSecond,
      conversionSpeedMBPerSecond,
      ...additionalData,
    })
  }

  return { startUpload, startConversion, stop }
}
